export default "__VITE_ASSET__BQzVRWAH__"